import React from 'react'
import {
  Container,
  Grid,
  Card,
  CardMedia,
  Typography,
  Box,
} from '@mui/material'
import { IMAGE_BASE_PATH_DBRADC } from '../../../Config/Config'

const imageData = [
  {
    id: 1,
    url: 'dbradc/Student_Life/Disability Facilities/DSC03605.JPG',
  },
  {
    id: 2,
    url: 'dbradc/Student_Life/Disability Facilities/DSC03609.JPG',
  },
  {
    id: 3,
    url: 'dbradc/Student_Life/Disability Facilities/WhatsApp Image 2025-04-17 at 5.09.35 PM (1).jpeg',
  },
]

const ImageGallery = () => {
  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h4" component="h1" fontWeight="bold">
          Disability Facilities
        </Typography>
        <Typography variant="subtitle1" color="text.secondary">
          We have a well-equipped facility for differently-abled students.
        </Typography>
      </Box>

      <Grid container spacing={3}>
        {imageData.map((img) => (
          <Grid item key={img.id} xs={12} sm={6} md={4}>
            <Card sx={{ borderRadius: 3, overflow: 'hidden', boxShadow: 3 }}>
              <CardMedia
                component="img"
                image={IMAGE_BASE_PATH_DBRADC + img.url}
                alt={`Image ${img.id}`}
                sx={{
                  width: '100%',
                  height: { xs: 200, sm: 250, md: 300 },
                  objectFit: 'cover',
                }}
              />
            </Card>
          </Grid>
        ))}
      </Grid>
    </Container>
  )
}

export default ImageGallery
